import { qsOptional } from '@/scripts/core/global'
import { ProductFormGeneric } from '@/scripts/product-form-context/ProductFormGeneric'

export class StickyCta extends ProductFormGeneric {
	static htmlSelector = 'product-sticky-cta'
	stickyAnchor?: HTMLElement
	siteFooter?: HTMLElement
	share?: HTMLButtonElement
	notification?: HTMLElement

	constructor() {
		super()
		this.stickyAnchor = qsOptional('[data-sticky-anchor]')
		this.siteFooter = qsOptional('.footer__item')
		this.share = qsOptional('[data-uc-share]', this)
		this.notification = qsOptional('[data-uc-sticky-notification]')
		if (this.share) this.share.addEventListener('click', this.copyShareLink.bind(this))
		this.createObserver()
	}

	createObserver() {
		let observer = new IntersectionObserver((entries: IntersectionObserverEntry[], _: IntersectionObserver) => {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop
			const firstEntry = entries[0]
			if (!firstEntry) return
			if (
				(firstEntry.boundingClientRect.bottom < 0 ||
					firstEntry.boundingClientRect.y > firstEntry.boundingClientRect.height) &&
				scrollTop > 500
			) {
				this.classList.add('show')
			} else {
				this.classList.remove('show')
			}
		})

		if (this.stickyAnchor) observer.observe(this.stickyAnchor)
		if (this.siteFooter) observer.observe(this.siteFooter)
	}

	copyShareLink(e: Event) {
		e.preventDefault()
		if (!this.share) return
		const copyText = this.share.getAttribute('data-url')
		if (copyText && this.notification) {
			navigator.clipboard.writeText(copyText)
			this.notification.classList.add('show')
			window.setTimeout(() => {
				this.notification?.classList.remove('show')
			}, 2500)
		}
	}
}
